import { api, setToken } from "./client";
import type { MessageOut, MeOut, TokenResponse, UsernameAvailability } from "./types";

export async function signup(input: { username: string; email: string; password: string }) {
  return api.post<MessageOut>("/auth/signup", input, { auth: false });
}

export async function login(input: { identifier: string; password: string }) {
  const token = await api.post<TokenResponse>("/auth/login", input, { auth: false });
  setToken(token.access_token);
  return token;
}

export async function logout() {
  setToken(null);
}

// Portal one-click login: swap the short-lived, single-use token from the
// `?token=` query param for a real session, then store it like a normal login.
export async function exchangeSsoToken(token: string) {
  const result = await api.post<TokenResponse>("/auth/sso/exchange", { token }, { auth: false });
  setToken(result.access_token);
  return result;
}

export async function authMe() {
  return api.get<MeOut>("/auth/me");
}

export async function verifyEmail(token: string) {
  return api.post<MessageOut>("/auth/verify-email", { token }, { auth: false });
}

export async function resendVerification(email: string) {
  return api.post<MessageOut>("/auth/resend-verification", { email }, { auth: false });
}

export async function requestPasswordReset(email: string) {
  return api.post<MessageOut>("/auth/password-reset/request", { email }, { auth: false });
}

export async function confirmPasswordReset(input: { token: string; new_password: string }) {
  return api.post<MessageOut>("/auth/password-reset/confirm", input, { auth: false });
}

export async function checkUsernameAvailability(candidate: string) {
  return api.get<UsernameAvailability>(
    `/auth/username-availability/${encodeURIComponent(candidate)}`,
    { auth: false },
  );
}
